import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos demais relatórios PJ). */
export type CartPjJob = ReportJob;
export type CartPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da CART PJ. */
@Injectable({ providedIn: 'root' })
export class CartPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'cart-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.cartPj;
}
